import { IUserUpdatePost } from "@/interfaces"
import { mapUserFromApiResponse } from "@/mappers/UserMappers"
import Endpoints from "@/network/Endpoints"
import Network from "@/network/Network"
import { useSessionStore } from "@/store/useSessionStore"

export default class UserService {
    static update = (params: IUserUpdatePost) => {
        const id = useSessionStore().session?.id
        return Network.post<any>(`${Endpoints.users}/${id}/update`, params)
    }
    static syncSession = async () => {
        const store = useSessionStore()
        const session = store.session
        if (!session) { return }
        const res = await Network.get(`${Endpoints.users}/${session.id}`)
        store.updateSession(mapUserFromApiResponse(res))
    }
}